"use client";

import { useClient } from "@tosize/ui";
import type { ComponentProps } from "react";

interface Props extends ComponentProps<"button"> {
	data: ShareData;
}

export function ShareButton({ data, ...props }: Props) {
	const { isClient } = useClient();

	if (!isClient || navigator.share === undefined) {
		return null;
	}

	return (
		<button
			type="button"
			onClick={() => {
				if (navigator.share) {
					void navigator.share(data);
				}
			}}
			{...props}
		/>
	);
}
